import env from "./environment";
import { getGatewayBaseUrl } from "./gateway";

export const API_CONFIG = {
  baseURLs: {
    smartOps: env.API_BASE_URL,
    frontend: window.location.origin,
    base: env.API_BASE_URL,
  },
  timeouts: {
    default: env.API_TIMEOUT || 10000,
    health: 10000,
    upload: 60000,
    long: 120000,
  },
  retries: {
    default: env.API_RETRY_ATTEMPTS || 3,
    health: 1,
    critical: 5,
  },
  ai: {
    maxTokens: env.AI_MAX_TOKENS || 4096,
    defaultTemperature: 0.7,
    defaultModel: "gpt-4",
  },
  database: {
    defaultPort: env.DATABASE_DEFAULT_PORT || 5432,
    defaultHost: "database-host",
    connectionTimeout: 5000,
  },
  headers: {
    default: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    upload: {
      "Content-Type": "multipart/form-data",
    },
  },
};

/** Gateway path catalog for callers still on API_ENDPOINTS. Prompt/gov SoT: governance-api. */
export const API_ENDPOINTS = {
  niceTravel: {
    agentChat: "/v1/booking-agent/chat",
  },

  ingest: {
    health: "/v1/ingest/health",
    url: "/v1/ingest/url",
    urls: "/v1/ingest/urls",
    crawl: "/v1/ingest/crawl",
    sources: "/v1/ingest/sources",
    sourcesSchedule: "/v1/ingest/sources/schedule",
    sourcesRun: "/v1/ingest/sources/run",
    sourcesRunOne: (name: string) => `/v1/ingest/sources/run/${encodeURIComponent(name)}`,
    sourcesPages: (name: string) => `/v1/ingest/sources/${encodeURIComponent(name)}/pages`,
    sourcesIngest: (name: string) => `/v1/ingest/sources/${encodeURIComponent(name)}/ingest`,
    sourcesRemove: (name: string) => `/v1/ingest/sources/${encodeURIComponent(name)}/remove`,
  },

  context: {
    catalog: "/v1/context/catalog",
    catalogDataGroupSimulate: (sourceService: string, entityType: string) =>
      `/v1/context/catalog/data-groups/${encodeURIComponent(sourceService)}/${encodeURIComponent(entityType)}/simulate`,
    replay: (serviceId: string) => `/v1/context/replay/${encodeURIComponent(serviceId)}`,
  },

  knowledgePolicy: {
    effective: "/v1/knowledge-policy/effective",
    tenant: (tenantId: string) => `/v1/knowledge-policy/tenants/${encodeURIComponent(tenantId)}`,
  },
};

export type ApiMode = "live";

export const getApiMode = (): ApiMode => "live";

export const getApiUrl = (endpoint: string): string => {
  const p = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${getGatewayBaseUrl()}${p}`;
};
